import React, { useContext, useEffect, useState } from 'react'
import './style/window.css'

import cjt from '../../assets/icon/dright.png'
import returnTop from '../../assets/icon/returnTop.png'
import { Alert, Menu, Pagination, Spin } from 'antd'
import classNames from 'classnames'
import WeekHot from '../../assembly/weekHot/weekHot'
import AllRank from '../../assembly/allRanking/allRank'
import { useLocation, useNavigate } from 'react-router-dom'
import api from '../../uitil/api'
import { encode } from 'js-base64'
import { CountContext } from '../../App'

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  }
}
//选项卡导航数据
const menuItems = [
  getItem('全部软件', '1101', null),
  getItem('病毒安全', '1102', null, [
    getItem('病毒防护', '110201'),
    getItem('防火墙类', '110202'),
    getItem('密码工具', '110203'),
    getItem('系统安全', '110204'),
    getItem('卸载清理', '110205'),
  ]),
  getItem('家用软件', '1103', null, [
    getItem('日程安排', '110301'),
    getItem('时钟日历', '110302'),
    getItem('信息管理', '110303'),
    getItem('占卜算命', '110304'),
  ]),
  getItem('教育教学', '1104', null, [
    getItem('等级考试', '110401'),
    getItem('电脑学习', '110402'),
    getItem('辅助设计', '110403'),
    getItem('教学管理', '110404'),
    getItem('理科工具', '110405'),
    getItem('其他教育', '110406'),

    5,
  ]),
  getItem('开发工具', '1105', null, [
    getItem('开发控件', '110501'),
    getItem('其他开发', '110502'),
    getItem('数据库类', '110503'),
    getItem('网络编程', '110504'),
  ]),
  getItem('媒体软件', '1106', null, [
    getItem('k歌软件', '110601'),
    getItem('解码器', '110602'),
    getItem('媒体插件', '110603'),
    getItem('媒体管理', '110604'),
    getItem('媒体其他', '110605'),
    getItem('视频编辑', '110606'),
  ]),
  getItem('其他软件', '1107', null, [
    getItem('其他', '110701'),
    getItem('收藏管理', '110702'),
    getItem('手机相关', '110703'),
    getItem('行业软件', '110704'),
  ]),
  getItem('图形软件', '1108', null, [
    getItem('Flash相关', '110801'),
    getItem('Icon相关', '110802'),
    getItem('cad图形', '110803'),
    getItem('电子相册', '110804'),
    getItem('动画制作', '110805'),
    getItem('屏幕截图', '110806'),
  ]),
  getItem('网络软件', '1109', null, [
    getItem('FTP工具', '110901'),
    getItem('QQ专区', '110902'),
    getItem('服务器工具', '110903'),
    getItem('聊天工具', '110904'),
    getItem('聊天相关', '110905'),
    getItem('搜索工具', '110906'),
  ]),
  getItem('系统工具', '1110', null, [
    getItem('备份工具', '111001'),
    getItem('磁盘管理', '111002'),
    getItem('分区管理', '111003'),
    getItem('关盘工具', '111004'),
    getItem('内存管理', '111005'),
    getItem('拼音输入', '111006'),
  ]),
  getItem('行业软件', '1111', null, [
    getItem('仓储物流', '111101'),
    getItem('工程建筑', '111102'),
    getItem('机械电子', '111103'),
    getItem('交通运输', '111104'),
    getItem('商务管理', '111105'),
    getItem('行政管理', '111106'),
  ]),
  getItem('应用软件', '1112', null, [
    getItem('pdf阅读器', '111201'),
    getItem('办公工具', '111202'),
    getItem('表格处理', '111203'),
    getItem('电子阅读', '111204'),
    getItem('翻译软件', '111205'),
    getItem('记事管理', '111206'),
  ]),
]

export default function Win() {
  //获取路由参数
  const { pathname } = useLocation()
  //选项卡导航
  const [openKeys, setOpenKeys] = useState([])
  //初始化调用一次
  useEffect(() => {
    window.scrollTo(0, 0)
    winWeeks('11')
    if (pathname === '/window') {
      document.title = '空特下载站'
    }
    const a = pathname.slice(8, 12)
    const b = pathname.slice(13, 19)
    if (a && b) {
      setOpenKeys([b, a])
      security(a, b)
    } else {
      setOpenKeys(['1101'])
      security()
    }
  }, [pathname])
  const rootSubmenuKeys = [
    '1101',
    '1102',
    '1103',
    '1104',
    '1105',
    '1106',
    '1107',
    '1108',
    '1109',
    '1110',
    '1111',
    '1112',
  ]
  //菜单点击切换
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }
  //选项卡
  const [table, setTable] = useState(1)
  //内容数据

  //推荐
  const [recommends, setRecommends] = useState([])

  //获取context上下文总排行榜
  const value = useContext(CountContext)
  //本周热门
  const [winWeek, setWinWeek] = useState([])
  const winWeeks = async (weeksApi) => {
    await api.get(`hot/sumType/${weeksApi}`).then((data) => {
      setWinWeek(data)
    })
  }

  //请求接口
  const security = async (softType = '1101', subSoftType = '110101') => {
    await api
      .get(`query/sumType/11/softType/${softType}/subSoftType/${subSoftType}`)
      .then((data) => {
        setRecommends(data)
      })
  }

  //分页
  //页数
  const [current, setCurrent] = useState(1)
  // 用于存储每页的数据
  const [recommend, setRecommend] = useState([])
  //每页目数
  const [pageSize, setPageSize] = useState(20)

  const onChange = (page) => {
    setCurrent(page)
    window.scrollTo(0, 0)
  }

  // 根据当前页码和每页条目数获取当前页的数据
  const getCurrentPageData = (items) => {
    const startIndex = (current - 1) * pageSize // 假设每页条目数为 20，可以根据需要修改
    const endIndex = startIndex + pageSize
    const page = items.slice(startIndex, endIndex)
    return setRecommend(page)
  }
  useEffect(() => {
    getCurrentPageData(recommends)
  }, [current, recommends, pageSize, table])

  //跳转路由
  const history = useNavigate()
  //返回顶部
  const [scrollPosition, setScrollPosition] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }
    window.addEventListener('scroll', handleScroll)

    const myElement = document.getElementsByClassName('retuntop')[0]
    if (scrollPosition > 0) {
      myElement.style.display = 'block'
      myElement.classList.remove('move-down')
      myElement.classList.add('move-up')
    } else {
      myElement.classList.remove('move-up')
      myElement.classList.add('move-down')
    }
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])

  return (
    <>
      <div className="win_all">
        <div className="win_left">
          <p>分类</p>
          <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectedKeys={openKeys}
            defaultSelectedKeys={openKeys}
            style={{
              width: 150,
              backgroundColor: 'white',
            }}
            items={menuItems}
            onClick={(e) => {
              history('/')
              setCurrent(1)
              setTable(1)
              setRecommends([])
              if (e.key === '1101') {
                setOpenKeys(['1101'])
                history(`window`)
                security(e.keyPath[0])
              } else {
                history(`window/${e.keyPath[1]}/${e.keyPath[0]}`)
                security(e.keyPath[1], e.keyPath[0])
              }
            }}
          />
        </div>
        <div className="win_center">
          <div className="center_top">
            <span>全部WIN软件</span>
            <ul>
              <li
                className={classNames({ active: table === 1 })}
                onClick={() => {
                  setTable(1)
                  setCurrent(1)
                  const commendId = recommends.sort((a, b) => {
                    return a.id - b.id
                  })
                  setRecommends(commendId)
                }}>
                推荐
              </li>
              <li
                className={classNames({ active: table === 2 })}
                onClick={() => {
                  setTable(2)
                  setCurrent(1)
                  const sortNews = recommends.sort((a, b) => {
                    return (
                      Date.parse(b.publish_date) - Date.parse(a.publish_date)
                    )
                  })
                  setRecommend(sortNews)
                }}>
                最新
              </li>
              <li
                className={classNames({ active: table === 3 })}
                onClick={() => {
                  setTable(3)
                  setCurrent(1)
                  const sortDownload = recommends.sort((a, b) => {
                    return b.download_count - a.download_count
                  })
                  setRecommend(sortDownload)
                }}>
                下载
              </li>
              <li
                className={classNames({ active: table === 4 })}
                onClick={() => {
                  setTable(4)
                  setCurrent(1)
                  const sortComment = recommends.sort((a, b) => {
                    return b.remark_count - a.remark_count
                  })
                  setRecommend(sortComment)
                }}>
                评论
              </li>
            </ul>
          </div>
          <div className="center_bottom">
            {recommends.length ? (
              <ul>
                {table === 1 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:
                            {Math.floor(item.download_count / 10000).toFixed(1)}
                            万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 2 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:
                            {Math.floor(item.download_count / 10000).toFixed(1)}
                            万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 3 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:
                            {Math.floor(item.download_count / 10000).toFixed(1)}
                            万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 4 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:
                            {Math.floor(item.download_count / 10000).toFixed(1)}
                            万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
              </ul>
            ) : (
              <Spin tip="Loading...">
                <Alert style={{ height: '50px' }} />
              </Spin>
            )}
          </div>
          <div className="fenye">
            <Pagination
              current={current}
              onChange={onChange}
              onShowSizeChange={(current, pageSize) => {
                setCurrent(current)
                setPageSize(pageSize)
              }}
              total={recommends.length}
              hideOnSinglePage={true}
              pageSize={pageSize}
            />
          </div>
        </div>

        <div className="win_right">
          <WeekHot hot={winWeek} />
          <AllRank hot={value.winHot} />
        </div>
      </div>
      <div
        className="retuntop"
        onClick={() => {
          window.scrollTo(0, 0)
        }}>
        <img src={returnTop} alt="" />
      </div>
    </>
  )
}
